<app-splash-screen></app-splash-screen>
<!--{{ message | async | json }}-->
<router-outlet></router-outlet>
